document.addEventListener('DOMContentLoaded', function () {

  const stickyBar = document.getElementById('OvaroStickyATC');
  const stickyButton = document.getElementById('OvaroStickyATCButton');

  if (!stickyBar || !stickyButton) {
    return;
  }


  /*
   * Find the REAL Add To Cart button
   *
   * This is the button already present
   * on your Ovaro product page.
   */

  const originalATC =
    document.querySelector('.product-form__buttons .product-form__submit') ||
    document.querySelector('product-form .product-form__submit') ||
    document.querySelector('button[name="add"]');


  if (!originalATC) {

    console.warn(
      'Ovaro Sticky ATC: Original Add to Cart button not found.'
    );

    return;
  }


  /*
   * Show sticky ATC only when the original
   * Add To Cart button is NOT visible.
   */

  const observer = new IntersectionObserver(

    function (entries) {

      const entry = entries[0];

      if (entry.isIntersecting) {

        /*
         * Original ATC is visible
         * → hide sticky
         */

        stickyBar.classList.remove('is-visible');

        stickyBar.setAttribute(
          'aria-hidden',
          'true'
        );

      } else {

        /*
         * Original ATC has passed out of viewport
         * → show sticky
         */

        stickyBar.classList.add('is-visible');

        stickyBar.setAttribute(
          'aria-hidden',
          'false'
        );

      }

    },

    {
      threshold: 0.1
    }

  );


  observer.observe(originalATC);


  /*
   * Sticky ATC CLICK
   *
   * IMPORTANT:
   * It does NOT add the product directly.
   *
   * It scrolls to the ORIGINAL ATC section.
   */

  stickyButton.addEventListener(
    'click',
    function () {

      originalATC.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

    }
  );

});